import React, { useMemo, useEffect } from "react";
import { useStore } from "stores/connect";
import { Spinner } from "components/common";
import ForwarderInputStateLabel from "./ForwarderInputStateLabel";
import ForwarderInputStatesStore, { ForwarderInputStatesActions } from "../stores/ForwarderInputStatesStore";
const ForwarderInputStateBadge = ({ forwarder = void 0, input }) => {
  const { forwarderInputStates: states } = useStore(ForwarderInputStatesStore);
  useEffect(() => {
    ForwarderInputStatesActions.register();
    return () => ForwarderInputStatesActions.unregister();
  }, []);
  const matchingState = useMemo(() => {
    if (!forwarder) {
      return void 0;
    }
    return (states || []).filter((state) => state.forwarder_id === forwarder.id).find((state) => state.input_id === input.id);
  }, [input, forwarder, states]);
  const inputState = matchingState == null ? void 0 : matchingState.state;
  const stateMessage = matchingState == null ? void 0 : matchingState.state_message;
  const hasResults = states !== null;
  if (!hasResults) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(ForwarderInputStateLabel, { state: inputState, stateMessage });
};
export default ForwarderInputStateBadge;
